<script setup lang="ts">
import type { FaqComponentModel } from '@su4r-frontend/api';
defineProps<FaqComponentModel>();
</script>

<template>
    <section class="tile flex flex-col gap-4 bg-white" :class="$attrs.class">
        <header class="flex flex-col gap-4">
            <h2 v-if="title" :id="$attrs.id as string" data-section-title class="order-2 text-2xl">
                {{ title }}
            </h2>
            <h3 v-if="subTitle" class="font-body order-1 uppercase">
                {{ subTitle }}
            </h3>
        </header>

        <AccordionItem
            v-for="(item, index) in items"
            :key="`item-${index}`"
            v-bind="item"
            class="border-b border-black/10 last-of-type:border-b-0" />
    </section>
</template>
